<template>
    <div class="list">
        <Head-view :showStyle="'0'"></Head-view>
        <div class="main">
            <div class="breadcrumb">机构列表</div>
            <div class="nav">
                <div class="searchLeft">
                    <div class="searchInp">
                        <el-input
                            v-model="searchVal"
                            prefix-icon="el-icon-search"
                            placeholder="请输入名称或编码"
                        ></el-input>
                    </div>
                    <div class="searchBtn" @click="handleSearchData()">
                        搜索
                    </div>
                </div>
                <div class="institutionAddBtn" @click="addInstitution()">
                    新建机构
                </div>
            </div>

            <div class="showTba">
                <div class="bodyTable">
                    <el-table
                        :data="tableData"
                        style="width: 100%; max-height: 489px"
                        height="489px"
                        stripe
                        v-loading="loading"
                    >
                        <el-table-column label="logo" width="100">
                            <template slot-scope="scope">
                                <div class="logo">
                                    <img :src="scope.row.logo" alt="" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="机构名称"
                            width="120"
                        >
                        </el-table-column>
                        <el-table-column prop="code" label="机构代号" width="120">
                        </el-table-column>
                        <el-table-column prop="city" label="城市" width="120">
                        </el-table-column>
                        <el-table-column label="负责人" width="130">
                            <template slot-scope="scope">
                                <div
                                    v-html="scope.row.people"
                                    class="peoplePhone"
                                ></div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="联系地址"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column label="有效期" width="100">
                            <template slot-scope="scope">
                                <div
                                    :class="[
                                        scope.row.timeEnd ? 'btnDelColor' : '',
                                    ]"
                                >
                                    {{ scope.row.expireDate }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="createDate"
                            label="创建时间"
                            width="140"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="routeCount"
                            label="路线数"
                            width="90"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="taskCount"
                            label="任务数"
                            width="90"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="placeCount"
                            label="点位数"
                            width="90"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="staffCount"
                            label="人员数"
                            width="90"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="faultCount"
                            label="故障数"
                            width="90"
                        >
                        </el-table-column>

                        <el-table-column fixed="right" label="操作" width="150">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleEide(scope.$index, scope.row)"
                                    type="text"
                                    size="small"
                                    class="btnColor"
                                    >编辑</el-button
                                >
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="removeInst(scope.$index, scope.row)"
                                    class="btnDelColor"
                                    >删除</el-button
                                >
                                <el-button
                                    type="text"
                                    size="small"
                                    class="btnColor"
                                    @click="replacePassword(scope.row)"
                                    >重置密码</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.currentPage"
                        :page-sizes="[10, 40, 100, 400]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
import { getTime } from "@/untils/tools";
export default {
    name: "list",
    data() {
        return {
            searchVal: "",

            tableData: [],
            pagination: {
                total: 0,
                currentPage: 1,
                pageSize: 10,
            },

            loading: true,
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.getInstDataInfo();
    },
    
    methods: {
        getInstDataInfo() {
            this.loading = true;
            let data = {
                token: this.getCookie(),
                page: this.pagination.currentPage,
                limit: this.pagination.pageSize,
                keyword: this.searchVal,
            };
            this.request
                .post(this.baseUrl + "Institution/getInsList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.pagination.total = res.data.totalCount;
                        if (res.data.list.length >= 0) {
                            let nowTime = new Date().getTime();
                            let arr = [];
                            res.data.list.forEach((item, key) => {
                                let str =
                                    item.director + `<br />(${item.phone})`;
                                arr.push(item);
                                arr[key]["people"] = str;
                                if (
                                    getTime(item.expireDate, "getTime") <
                                    nowTime
                                ) {
                                    arr[key]["timeEnd"] = true;
                                } else {
                                    arr[key]["timeEnd"] = false;
                                }
                            });
                            this.tableData = arr;
                            this.loading = false;
                        }
                    } else {
                    }
                });
        },

        addInstitution() {
            this.$router.push("/institutionAdd");
        },
        handleSizeChange(e) {
            this.pagination.pageSize = e;
            this.getInstDataInfo();
        },
        handleCurrentChange(e) {
            this.pagination.currentPage = e;
            this.getInstDataInfo();
        },
        handleSearchData() {
            this.searchVal = this.searchVal.trim();
            this.getInstDataInfo();
        },
        handleEide(index, row) {
            this.$router.push({
                path: "/institutionAdd",
                query: {
                    id: row.insId,
                },
            });
        },
        replacePassword(row) {
            //重置密码
            this.$prompt(`账号：${row.name}`, "重置密码", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            })
                .then(({ value }) => {
                    let data = {
                        token: this.getCookie(),
                        insId: row.insId,
                        newPassword: value,
                    };
                    this.request
                        .post(
                            this.baseUrl + "/Login/resetInsManagerPassword",
                            data
                        )
                        .then((res) => {
                            if (res.code == 0 && res.data.result) {
                                this.$message({
                                    type: "success",
                                    message:
                                        "重置成功，密码已修改。改为: " + value,
                                });
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message({
                                type: "warning",
                                message: '修改失败',
                            });
                        });

                    // if (value) {
                    //     this.$message({
                    //         type: "success",
                    //         message: "重置成功，密码已修改。改为: " + value,
                    //     });
                    // }

                    if (!value) {
                        this.$message({
                            type: "error",
                            message: "重置失败，请稍候再试",
                        });
                    }
                })
                .catch(() => {});
        },

        removeInst(index, row) {
            this.$confirm(
                "删除后不可恢复，数据即将丢失，请谨慎选择。",
                "确定要删除本机构吗？",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    let data = {
                        token: this.getCookie(),
                        insId: row.insId,
                    };
                    this.request
                        .post(this.baseUrl + "/Institution/deleteIns", data)
                        .then((res) => {
                            if (res.code == 0 && res.data.result == true) {
                                this.$message({
                                    type: "success",
                                    message: res.msg,
                                });
                                this.tableData.splice(index, 1);
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: "删除失败",
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message({
                                type: "error",
                                message: err,
                            });
                        });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="less" scoped>
.list {
    height: 100vh;

    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            margin-left: 7px;
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
        }
        .nav {
            margin-top: 24px;
            margin-left: 7px;
            height: 68px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            .searchLeft {
                float: left;
                margin: 12px 0 0 20px;
                display: flex;
                flex-direction: row;
                width: 300px;
                height: 40px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                .searchInp {
                    width: 211px;
                }
                .searchBtn {
                    margin-left: 20px;
                    width: 68px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: rgba(4, 134, 254, 1);
                    border-radius: 4px;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                }
            }

            .institutionAddBtn {
                margin: 14px 17px 0 0;
                float: right;
                width: 95px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                background: rgba(4, 134, 254, 1);
                border-radius: 4px;
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }
        }
        .showTba {
            margin-top: 24px;
            margin-right: 7px;
            padding: 16px 17px 0 31px;
            height: 618px;
            background: #fff;
            .bodyTable {
                width: 100%;
                height: 500px;
                overflow: hidden;
                overflow-y: auto;
            }
            .pageination {
                margin-top: 69px;
                text-align: right;
            }
            .logo {
                width: 32px;
                height: 32px;
                background: rgba(204, 204, 204, 1);
                img {
                    width: 100%;
                }
            }
        }
    }

    .btnColor {
        color: rgba(25, 137, 250, 1);
    }

    .btnDelColor {
        color: rgba(255, 87, 51, 1);
    }
}
</style>